import { useEffect } from "react";

/**
 * detect if app has been inactive and is being resumed.
 */
export function useResume(handler: () => void) {

    useEffect(() => {
        let previous = new Date().getTime();
        const interval = setInterval(() => {
            const current = new Date().getTime();
            if (current - previous > 5000) {
                handler();
            }
            previous = current;
        }, 1000);

        return () => clearInterval(interval);
    }, []);
}